import { setPageTitle } from '../../../../utils/utilities'
import Audio from './Audio'
import Images from './Images'
import Video from './Video'

const Assets = () => {
  setPageTitle('Content | Assets')

  return (
    <div className="w-full flex flex-col p-2 xl:p-5 gap-4 divide-y divide-neutral-200 dark:divide-neutral-700">
      <Images />
      <Video />
      <Audio />
    </div>
  )
}

export default Assets
